module.exports = __webpack_public_path__ + "static/media/xenon-bg.b2a74935.mp4";